import { TCustomSortDirection } from '@app/modules/table/children/table-column-action/interfaces/table-column-action.type';
import { FuiSelectItemService } from '@fui/fui-components';
import { defaultStringNameItemService, IStringNameItem } from '@interfaces/fui-components/select.interface';

/**
 * Переводы для окна действий над столбцом, которые различаются в зависимости от действия
 */
export interface ITranslations {
    /** Тайтл окна */
    title: string; // Тайтл окна
    /** Подпись первого поля */
    userColumnNameLabel: string;
    /** Подпись второго поля */
    sortOrderOrSearchValueLabel: string;
}

/**
 * Значения полей
 */
export interface IValueForm {
    /** Например: field__1233 */
    userColumnName: string;
    /** Направление сортировки или значение для поиска */
    sortOrderOrSearchValue?: TCustomSortDirection | string;
}

export interface IFilterRun {
    /** Например: field__1233 */
    userColumnName: string;
    searchValue: string;
    /** Координата для открытия popup */
    left?: number;
    /** Координата для открытия popup */
    bottom?: number;
}

export interface ISortRun {
    /** Например: field__1233 */
    userColumnName: string;
    sortDirection: TCustomSortDirection;
}

export interface IGroupRun {
    /** Например: field__1233 */
    userColumnName: string;
    sortDirection: TCustomSortDirection;
}

export interface ISummarizeRun {
    /** Например: field__1233 */
    userColumnName: string;
}

export interface IRenameRun {
    /** Например: field__1233 */
    userColumnName: string;
    /** Человеко-читаемое название колонки */
    columnLabel: string;
}

export interface IHideRun {
    /** Например: field__1233 */
    userColumnName: string;
}

export interface IPinOrUnpinRun {
    /** Например: field__1233 */
    userColumnName: string;
    isSticky: boolean;
}

/** Текущее состояние сортировки */
export interface ISort {
    /** Например: field__1233 */
    fieldName: string;
    /** Направление сортировки */
    direction: TCustomSortDirection;
}

/** Расширенный интерфейс для опций с флагом доступности */
export interface IStringNameItemDisabled extends IStringNameItem {
    disabled?: boolean;
    type?: string;
}

/**
 * Пример сервиса элементов списка с полями id=string и name=string
 */
export const disabledStringNameItemService: FuiSelectItemService<IStringNameItemDisabled, string> = {
    ...defaultStringNameItemService,
    disabled: (item) => item.disabled,
};

/** Данные для Popup изменения имени колонки */
export interface IRenameData {
    /** Заголовок Popup */
    titlePopup: string;
    /** Текущий заголовок столбца */
    titleColumn: string;
    /** Наименование столбца */
    nameColumn: string;
}

/** Данные для сохранения нового имени колонки */
export interface IRenameDataSave {
    title: string;
    /** Наименование столбца */
    name: string;
}
